import Login from './login.json'
import Result from './result.json'
import Themes from './themes.json'
import Time from './time.json'
import Wallpaper from './wallpaper.json'
import VoteHistory from './vote_history.json'

export function getLocalJson() {
  return Object.assign({}, Login, Result, Themes, Time, Wallpaper, VoteHistory)
}